import { render } from "./vhpMenu.vue?vue&type=template&id=1fc2e7bb"
import script from "./vhpMenu.vue?vue&type=script&lang=js"
export * from "./vhpMenu.vue?vue&type=script&lang=js"

import "./vhpMenu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__